import React from 'react';
import PropTypes from 'prop-types';

import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

import { Field } from 'redux-form';

const PhoneInput = React.forwardRef(
  (
    {
      input,
      inputClassName,
      containerClassName,
      preferredCountries,
      onChange,
      disabled,
      value,
      formatOnInit,
      autoPlaceholder,
      inputProps,
      ...props
    },
    ref
  ) => (
    <IntlTelInput
      ref={ref}
      inputClassName={inputClassName}
      containerClassName={containerClassName}
      onPhoneNumberChange={(status, value, country) => {
        const newValue = {
          value,
          country: { dial: country.dialCode, code: country.iso2 },
        };
        input && input.onChange ? input.onChange(newValue) : onChange(newValue);
      }}
      onSelectFlag={(oldValue, country, newValue, isValid) => {
        if (oldValue.indexOf('+') === -1) {
          const value = {
            value: oldValue,
            country: { dial: country.dialCode, code: country.iso2 },
          };
          input && input.onChange ? input.onChange(value) : onChange(value);
        }
      }}
      disabled={disabled}
      value={
        (input && input.value && input.value.value) ||
        (value && value.value) ||
        ''
      }
      formatOnInit={formatOnInit}
      preferredCountries={preferredCountries}
      autoPlaceholder={autoPlaceholder}
      telInputProps={inputProps}
      {...props}
    />
  )
);

const FormPhoneInput = React.forwardRef(({ name, onChange, ...props }, ref) =>
  name ? (
    <Field
      component={PhoneInput}
      name={name}
      onChange={onChange}
      props={{ ...props, ref }}
    />
  ) : (
    <PhoneInput {...props} {...{ ref, onChange }} />
  )
);

PhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  containerClassName: PropTypes.string,
};

export default FormPhoneInput;
